import styled from "styled-components";

export const ShowsFilterContentWrapper = styled.div``;
